import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class DagService {

	private httpClient: HttpClient;

	constructor(
		private handler: HttpBackend
	) { 
		this.httpClient = new HttpClient(handler);
	}

	createDag(dagObj: any, dag_id: any): Observable<any> {
		return this.httpClient.post<any>(`${environment.externalResource}/dags/${dag_id}/dagRuns`, dagObj);
	}
}